import { render, staticRenderFns } from "./InvestmentFundsDataStudio.vue?vue&type=template&id=31a10696"
import script from "./InvestmentFundsDataStudio.vue?vue&type=script&lang=js"
export * from "./InvestmentFundsDataStudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports